<script lang="ts">
    import InView from "../InView.svelte"
    import OptInBlock from "../OptInBlock.svelte"
    import {
        initCryptcha,
        resetCryptcha,
        cryptchaSolution,
        cryptchaSolutionId,
        getUserCountry,
        getUserLanguage,
    } from "../../utils"
    import { location } from "../../store"
    import { getCachedEntries, postDBEntry } from "../../../api"

    export let block: ContentBlockEntry

    let formData: ContactFormEntry = {
        type: "contactForm",
        referrer: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        language: getUserLanguage(),
        country: getUserCountry(),
        subject: "",
        description: "",
        _s: "",
        _sId: "",
    }

    $: console.log(formData)

    let errorMessage = ""
    let success = false
    let loading = false

    function submit(e: Event) {
        e.preventDefault()
        formData.referrer = $location.path
        formData._s = $cryptchaSolution
        formData._sId = $cryptchaSolutionId

        loading = true
        success = false
        errorMessage = ""

        postDBEntry("form", formData)
            .then(() => {
                success = true
                // clear form
                Object.keys(formData).forEach((key) => {
                    if (key !== "type") formData[key] = ""
                })
                accepted = false
                if (typeof window !== "undefined") {
                    setTimeout(() => {
                        success = false
                    }, 5000)
                }
            })
            .catch((err) => {
                console.error(err)
                errorMessage = "An error occurred. Please try again later. (" + err.data?.message + ")"
            })
            .finally(() => {
                loading = false
            })

        resetCryptcha()
    }

    let cryptchaEl: HTMLDivElement

    let accepted = false

    let cryptchaInitialized = false

    $: if (cryptchaEl && !cryptchaInitialized && formData.firstname) {
        initCryptcha(cryptchaEl)
        cryptchaInitialized = true
    }
</script>

<div class="container tp-xxl bp-xxl" data-block-type="{block.type}">
    <h2>Contact</h2>
    <!-- Überschrift hier mit im Container weil Footer Element -->
    <div class="grid tp-l bp-l">
        <div class="col-md-6">
            <form on:submit="{submit}">
                <!-- Kontaktformular -->
                <div class="grid">
                    <div class="col-md-6 col-grid border-bottom">
                        <label for="first">First Name<span>*</span></label>
                        <input type="text" id="first" required bind:value="{formData.firstname}" />
                    </div>
                    <div class="col-md-6 col-grid border-bottom">
                        <label for="last">Last Name<span>*</span></label>
                        <input type="text" id="last" required bind:value="{formData.lastname}" />
                    </div>
                    <div class="col-md-6 col-grid border-bottom">
                        <label for="email">E-Mail<span>*</span></label>
                        <input type="email" id="email" required bind:value="{formData.email}" />
                    </div>
                    <div class="col-md-6 col-grid border-bottom">
                        <label for="phone">Phone</label>
                        <input type="text" id="phone" bind:value="{formData.phone}" />
                    </div>
                    <div class="col-md-6 col-grid border-bottom">
                        <label for="language">Language<span>*</span></label
                        ><!-- Weiß nicht genau, was hier für Auswahlmöglichkeiten entstehen sollen, ob filterbar oder nicht -->
                        <select id="language" bind:value="{formData.language}" required>
                            <option value="" disabled>Please select...</option>
                            <option value="de">Deutsch</option>
                            <option value="en">English</option>
                        </select>
                    </div>
                    <div class="col-md-6 col-grid border-bottom">
                        <!-- Dieses Element ist möglicherweise mit Filterbarem Dropdown? -->
                        <label for="country">Country<span>*</span></label>
                        {#if typeof window !== "undefined"}
                            {#await getCachedEntries("country", null, "name") then countries}
                                <select id="country" bind:value="{formData.country}" required>
                                    <option value="" selected disabled>Please select...</option>
                                    {#each countries as country}
                                        <option value="{country.code}">{country.name}</option>
                                    {/each}
                                </select>
                            {/await}
                        {/if}
                    </div>
                    <div class="col-12 col-grid border-bottom">
                        <label for="subject">Subject<span>*</span></label>
                        <input type="text" id="subject" required bind:value="{formData.subject}" />
                    </div>
                    <div class="col-12 col-grid border-bottom">
                        <label for="description">Message<span>*</span></label>
                        <textarea id="description" required bind:value="{formData.description}"></textarea>
                    </div>
                </div>
                {#if success}
                    <div class="success">
                        <p>Your message has been sent successfully.</p>
                    </div>
                {/if}
                {#if errorMessage}
                    <div class="error">
                        <p>{errorMessage}</p>
                    </div>
                {/if}
                <div class="grid align-center">
                    <div class="col-auto privacy">
                        <input type="checkbox" id="privacy" required bind:checked="{accepted}" />
                        <label class="checkbox-wrap" for="privacy"
                            ><span>Accept <a href="/legal-information" target="_blank">Privacy Policy</a></span></label
                        >
                    </div>
                    <div class="col-auto align-self-end">
                        <button
                            type="submit"
                            class="btn-primary"
                            disabled="{!$cryptchaSolution || !accepted || loading}">Send</button
                        >
                    </div>
                </div>
                <InView>
                    <div bind:this="{cryptchaEl}"></div>
                </InView>
            </form>
        </div>
        <div class="col-md-6 col-grid gap-m">
            <!-- Karte ausblenden wenn Cookie nicht zugestimmt wurde -->
            <OptInBlock key="googleMaps" let:rejectCallback>
                <InView>
                    <iframe
                        style="width: 100%; border: 0;"
                        title="Google Map"
                        class="map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2519.8640168553766!2d10.943461677531378!3d50.83368265969523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a4757fedfddfe3%3A0xaeeeb85aa94f5f5!2sSportident%20GmbH!5e0!3m2!1sde!2sde!4v1711540481545!5m2!1sde!2sde"
                        allowfullscreen="{false}"
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                </InView>
                <div>
                    <!-- TODO: Über Opt Out sprechen -->
                    <button on:click="{rejectCallback}">Hide google content</button>
                </div>
                <div slot="placeholder" let:acceptCallback>
                    <div class="background-image darken-background shadow border-radius-all border-radius-xl">
                        <figure>
                            <img src="/assets/img/markt-14.jpg" alt="Placeholder" />
                        </figure>
                    </div>
                    <div class="placeholder-message hp-xl">
                        This map is provided by Google. By enabling this content, your personal data may be processed by
                        the vendor and cookies may be set.
                        <button class="btn-primary" on:click="{acceptCallback}">Show google content</button>
                    </div>
                </div>
            </OptInBlock>
            <!-- Adressdaten im TIBI Admin änderbar machen -->
            <address>
                <strong>SPORTident GmbH</strong><br />
                Markt 14<br />
                99310 Arnstadt<br />
                Germany
            </address>
            <address>
                Phone: +49 3628 78300 (Mo-Fr 08.00-17.00)<br />
                Fax: +49 3222 4394769<br />
                Email: <a href="mailto:support@sportident.com">support@sportident.com</a>
            </address>
            <address>
                Timing Service<br />
                Phone: +49 3628 78303 (Mo-Fr 08.00-17.00)<br />
                Email: <a href="mailto:timing@sportident.com">timing@sportident.com</a>
            </address>
        </div>
    </div>
</div>

<style lang="less">
    button:disabled {
        opacity: 0.5;
    }

    .success {
        background-color: #d4edda;
        color: #155724;
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 0.25rem;
    }

    .error {
        background-color: #f8d7da;
        color: #721c24;
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 0.25rem;
    }
</style>
